import type { ReactNode } from "react";

import { IgTypography } from "@intelligems/ig-theme";
import { Stack } from "@mui/material";

interface AgenticLogicTabHeaderProps {
  title: string;
  description: ReactNode;
  /** Rendered opposite the title — a primary action for the tab. */
  action?: ReactNode;
}

/**
 * The page heading. The active tab owns it — each tab names itself and carries
 * its own primary action, and a second page-level title above the tab bar just
 * repeated the tab name. Type scale and action alignment match the experience
 * table pages (see `domains/experienceTablePages/ExperienceModulePageHeader.tsx`).
 */
export const AgenticLogicTabHeader = ({
  title,
  description,
  action,
}: AgenticLogicTabHeaderProps) => (
  <Stack
    pt={2}
    direction={{ xs: "column", sm: "row" }}
    alignItems={{ xs: "center", sm: "center" }}
    justifyContent="space-between"
    gap={2}
  >
    <Stack spacing={1}>
      <IgTypography component="h1" variant="h3" fontWeight={600}>
        {title}
      </IgTypography>
      <IgTypography color="text.secondary">{description}</IgTypography>
    </Stack>
    {action}
  </Stack>
);
